export default __webpack_public_path__ + "static/media/pexels-jeswin-thomas-1280162.4dd62989.jpg";